<template>
  <!-- Логотип задаётся в «Дизайне» админки сайта (192.168.1.88:5176/app/site/design) и общий
       для всех приложений; nginx проксирует /brand-logo с сайта (/api/brand/logo). -->
  <img :src="'/brand-logo'" alt="Zakupki HUB" class="w-auto object-contain" />
</template>
